<template>
  <section class="wrapper">
    <a-button class="button" type="link" @click="goBack" v-if="!isViewTemplates">
      <ArrowLeftOutlined /> <span>Volver a Mis Canales</span>
    </a-button>

    <TableWhatsappTemplates
      :data="templatesData"
      :loadingTable="loadingTable"
      @update="fetchData"
      @openCreateModal="handleOpenCreate"
      @openPreviewModal="handleOpenPreview"
      @openEditModal="handleOpenEdit"
      @openAssignModal="handleOpenAssign"
    />

    <CreateModal
      v-if="createModalVisible"
      :templatesData="templatesData"
      :visible="createModalVisible"
      :channelCustomerId="channelCustomerIdModal"
      @update="fetchData"
      @close="handleClose"
    />

    <PreviewModal
      :visible="previewModalOptions.visible"
      :template="previewModalOptions.template"
      @close="handleClose"
    />

    <EditModal
      v-if="editModalOptions.visible"
      :visible="editModalOptions.visible"
      :template="editModalOptions.template"
      @update="fetchData"
      @close="handleClose"
    />

    <AssignQueueModal
      v-if="assignModalOptions.visible"
      v-model:visible="assignModalOptions.visible"
      :wppTemplate="assignModalOptions.template"
      @update="fetchData"
    />
  </section>
</template>

<script>
import { defineComponent, onMounted, provide, reactive, ref, computed } from "vue";
import { ArrowLeftOutlined } from "@ant-design/icons-vue";
import { useRoute, useRouter } from "vue-router";

import { fetchTemplates } from "@/app/channels/services";

import TableWhatsappTemplates from "@/app/channels/components/tables/TableWhatsappTemplates.vue";

import CreateModal from "@/app/channels/components/modals/whatsappTemplates/CreateModal.vue";
import PreviewModal from "@/app/channels/components/modals/whatsappTemplates/PreviewModal.vue";
import EditModal from "@/app/channels/components/modals/whatsappTemplates/EditModal.vue";
import AssignQueueModal from "@/app/channels/components/modals/whatsappTemplates/AssignQueueModal.vue";

export default defineComponent({
  components: {
    ArrowLeftOutlined,
    TableWhatsappTemplates,
    CreateModal,
    PreviewModal,
    EditModal,
    AssignQueueModal,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const channelCustomerId = ref(route.params.channel_customer);
    const channelCustomerIdModal = ref(null);

    const loadingTable = ref(false);
    const templatesData = ref([]);

    const filters = reactive({
      search: "",
      category: "",
      state: "",
      status: "",
    });
    provide("filters", filters);

    const goBack = () => router.push("/channels/board");

    const isViewTemplates = computed(() => route.path == "/channels/template");

    const fetchData = async (identifierId = null) => {
      try {
        loadingTable.value = true;
        templatesData.value = [];
        if (identifierId) {
          channelCustomerId.value = identifierId;
        }

        if (channelCustomerId.value) {
          const response = await fetchTemplates({
            channelCustomerId: channelCustomerId.value,
            filters,
          });
          console.log(response, "RESPONSE WHATSAPP");
  
          templatesData.value = response;
        }
      } catch (error) {
        console.log(error);
      } finally {
        loadingTable.value = false;
      }
    };

    onMounted(async () => {
      await fetchData();
    });

    // Create Modal
    const createModalVisible = ref(false);

    const handleOpenCreate = (identifierId = null) => {
      channelCustomerIdModal.value = identifierId ?? channelCustomerId.value;
      createModalVisible.value = true;
    };

    // Preview Modal
    const previewModalOptions = reactive({
      visible: false,
      template: null,
    });

    const handleOpenPreview = (templateData) => {
      previewModalOptions.visible = true;
      previewModalOptions.template = templateData;
    };

    // Edit Modal
    const editModalOptions = reactive({
      visible: false,
      template: null,
    });

    const handleOpenEdit = (templateData) => {
      editModalOptions.visible = true;
      editModalOptions.template = templateData;
    };

    // Assign queue to tempalte
    const assignModalOptions = reactive({
      visible: false,
      template: null,
    });

    const handleOpenAssign = (templateData) => {
      assignModalOptions.visible = true;
      assignModalOptions.template = templateData;
    };

    const handleClose = () => {
      createModalVisible.value = false;
      previewModalOptions.visible = false;
      editModalOptions.visible = false;
      assignModalOptions.visible = false;
    };

    return {
      templatesData,
      fetchData,
      goBack,
      createModalVisible,
      handleOpenCreate,
      previewModalOptions,
      handleOpenPreview,
      editModalOptions,
      handleOpenEdit,
      assignModalOptions,
      handleOpenAssign,
      handleClose,
      isViewTemplates,
      loadingTable,
      channelCustomerIdModal,
    };
  },
});
</script>

<style lang="sass" scoped>
.wrapper
  padding: 8px 20px

.button
  padding: 0
</style>
